import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import { Route } from 'react-router';

import Layout from 'pages/Layout';

import RoutingEnum from 'constants/RoutingEnum';

import SessionStore from 'stores/SessionStore';

const subRoutes = [];


function requireAuth(nextState, replace) {
  if (!SessionStore.isLoggedIn()) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname }
    });
  }
}

_.each(RoutingEnum, (route) => {
  if (!route.disable) {
    subRoutes.push(
      <Route
        name={route.name}
        path={route.path}
        component={route.handler}
        key={route.name}
        onEnter={route.authRequired ? requireAuth : null}
      />
    );
  }
});

const routes = (
  <Route name="app" component={Layout}>
    {subRoutes}
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./scripts/routes.js